import React from "react"
import { actionKeys } from "@love-irish/i18n"
import { IconNews } from "@tabler/icons-react"
import BaseListItem from "../base"

export interface NewsSourceListItemProps {
  item: Record<string, any>
  className?: string
  /** Custom footer content to replace the default "Added by..." text */
  footer?: React.ReactNode
}

export const NewsSourceListItem: React.FC<NewsSourceListItemProps> = ({ item, className, footer }) => (
  <BaseListItem
    item={item}
    className={className}
    footer={footer}
    typeIcon={IconNews}
    typeLabel="News"
    testId="news-source-list-item"
    readMore={{ useI18n: true, actionKey: actionKeys.READ }}
    media={
      (item.imageUrl || item.thumbnailUrl) && (
        <a href={item.path}>
          <img loading="lazy"
            src={item.thumbnailUrl || item.imageUrl}
            alt={item.name}
            className="max-w-[100px] rounded-xl"
          />
        </a>
      )
    }
  />
)

export default NewsSourceListItem
